var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00033 1.604C4.02029 1.604 1.60449 4.0198 1.60449 6.99984C1.60449 9.97987 4.02029 12.3957 7.00033 12.3957C9.98036 12.3957 12.3962 9.97987 12.3962 6.99984C12.3962 4.0198 9.98036 1.604 7.00033 1.604ZM0.729492 6.99984C0.729492 3.53655 3.53704 0.729004 7.00033 0.729004C10.4636 0.729004 13.2712 3.53655 13.2712 6.99984C13.2712 10.4631 10.4636 13.2707 7.00033 13.2707C3.53704 13.2707 0.729492 10.4631 0.729492 6.99984Z",
    fill: "#D12D36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0004 4.229C7.24202 4.229 7.4379 4.42488 7.4379 4.6665V7.58317C7.4379 7.8248 7.24202 8.02067 7.0004 8.02067C6.75877 8.02067 6.5629 7.8248 6.5629 7.58317V4.6665C6.5629 4.42488 6.75877 4.229 7.0004 4.229Z",
    fill: "#D12D36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58366 9.33314C7.58366 9.6553 7.32249 9.91647 7.00033 9.91647C6.67816 9.91647 6.41699 9.6553 6.41699 9.33314C6.41699 9.01097 6.67816 8.7498 7.00033 8.7498C7.32249 8.7498 7.58366 9.01097 7.58366 9.33314Z",
    fill: "#D12D36"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export default ForwardRef;